const REVIEW_IMAGE_CDN_BASE = 'https://img.wowcruise.kr';

export const normalizeReviewImageUrl = (rawUrl) => {
  const input = String(rawUrl || '').trim();
  if (!input) return '';

  const cdnDirectMatch = input.match(/^https?:\/\/img\.wowcruise\.kr\/board_editor\/(.+)$/i);
  if (cdnDirectMatch) {
    return `${REVIEW_IMAGE_CDN_BASE}/board_editor/${cdnDirectMatch[1]}`;
  }

  const legacyPathMatch = input.match(/^\/upload\/board_editor\/(.+)$/i);
  if (legacyPathMatch) {
    return `${REVIEW_IMAGE_CDN_BASE}/board_editor/${legacyPathMatch[1]}`;
  }

  const directPathMatch = input.match(/^\/board_editor\/(.+)$/i);
  if (directPathMatch) {
    return `${REVIEW_IMAGE_CDN_BASE}/board_editor/${directPathMatch[1]}`;
  }

  const legacyFullUrlMatch = input.match(/^https?:\/\/[^/]+\/upload\/board_editor\/(.+)$/i);
  if (legacyFullUrlMatch) {
    return `${REVIEW_IMAGE_CDN_BASE}/board_editor/${legacyFullUrlMatch[1]}`;
  }

  return input;
};

export const normalizeReviewHtmlImages = (html) => {
  const raw = String(html || '');
  if (!raw) return '';

  return raw.replace(
    /(<img\b[^>]*\bsrc\s*=\s*["'])([^"']+)(["'][^>]*>)/gi,
    (_match, prefix, src, suffix) => `${prefix}${normalizeReviewImageUrl(src)}${suffix}`
  );
};

